<template>
  <div>
    <!-- <h2 class="text-center colorblue">Техническая поддержка</h2> -->
    <v-card class="colorblue pt-4 pr-4 pl-4 pb-4">
      <p><strong>Если у вас что-то не работает или работает не так, как хотелось бы, просим выполнить следующие действия:</strong>
      <ol>
        <li>выйдите из своего личного кабинета,</li>
        <li>нажмите Ctrl + R для Windows и Linux или Cmd + Shift + R на MacOS,</li>
        <li>зайдите в личный кабинет заново.</li>
      </ol>
      </p>
      <p><strong>Если это не поможет, сделайте пожалуйста скриншот страницы и напишите о проблеме на почту <a href='mailto:help@finexpert.pro' target="_blank">help@finexpert.pro</a></strong>
      <br>Мы постараемся оперативно Вам помочь.
      </p>



      <!-- <v-tabs v-model="tab" @change="ChangeTabUM" centered>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs> -->
    </v-card>
    <!-- <v-card>
      <v-tabs-items v-model="tab" class="mt-2">
        <v-tab-item>
          <v-card-text>
            <History/>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <NewTicket/>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card> -->
  </div>
</template>

<script>
// import History from "./history";
// import NewTicket from "./newTicket";

export default {
  components: {
    // History,
    // NewTicket
  },
  data() {
    return {
        tab: 1,
        items: [
          'Мои обращения', 'Новое обращение'
        ],
    };
  },

  methods: {
    ChangeTabUM() {
       this.$store
         .dispatch("ChangeTabUM",this.tab)
         .then(() => {})
         .catch(error => {
           alert(error);
         });
    }
  },
  mounted() {
    this.setTitle(`Техническая поддержка`)
  },
  //getCalculatorSettingsSimple
};
</script>

<style lang="sass">
</style>
